export default __webpack_public_path__ + "static/media/RubyNoBackground.483e731c.png";